
function saveConfiguration() {
    return expivi.saveConfiguration();
}

function fixPriceSku(result) {
  result.configured_products[0].articles = result.configured_products[0].articles.filter((item) => !!item.price_sku).map((item) => {
    return {
      ...item,
      models_sku: item.price_sku,
    }
  });
  return result;
}

function createVariant(savedBundle) {
    return new Promise(function (resolve, reject) {
        $.ajax({
            type: 'POST',
            url: '/apps/configurator',
            data: JSON.stringify({
                configuration: savedBundle.configured_products,
                productId: shopifyProductId
            }),
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
        }).done(function(createResult) {
            createResult.configuredProduct = savedBundle.configured_products[0];
            resolve(createResult);
        }).fail(reject);
    });
}

function addToCart(createResult) {
    return new Promise(function (resolve, reject) {

        const url = window.location.href;
        const searchParams = new URLSearchParams(window.location.search);

        const properties = {};
        Object.keys(createResult.options).forEach((key) => {
            properties['_'+key] = createResult.options[key];
        });

        let addJsResponse = {
            id: createResult.variant_id,
            properties: properties,
        };

        window[createResult.themeCallback](resolve, reject, addJsResponse, createResult);
    });
}

window.xpv_hooks_add_to_cart = function(context, event) {
    $button = $(context);
    shopifyProductId = $button.data('productId');

    // Disable button
    if ($button[0].hasAttribute('disabled')) {
        return false;
    }
    event.preventDefault();
    $button.attr('disabled', 'disabled');
    $button.addClass('loading');

    return Promise.resolve()
        .then(function() {
            return saveConfiguration();
        })
        .then(function(result) {
          return fixPriceSku(result);
        })
        .then(function(result) {
            return createVariant(result);
        })
        .then(function(result) {
            return addToCart(result)
        })
        .then(function() {
            if ($button.data('url') !== 'NONE') {
                window.location.href = $button.data('url');
            }

            // Don't let expivi handle add to cart
            return false;
        })
        .catch(function (error) {
            $button.removeAttr('disabled');
            $button.removeClass('loading');
            if (error && error.invalid) {
                alert(error.message);
                return;
            }
            throw error;
        });
}